import React, { useEffect, useState } from "react";
import API from "../../Service/Baseservice";
import { useNavigate } from "react-router-dom";
import Loading from "../../../Loading/loading";
import AdminView from "../../../Assets/img/Eye.svg";
import Search from "../../../Assets/img/search.png";
import { useLocation } from "react-router-dom";
const EligibilityCandidate = () => {
    const [candidate, setCandidate] = useState([]);
    const [loading, setLoading] = useState(true);
    const [languageId, setLanguageId] = useState(1);
    const [search, setSearch] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const [pageNumber, setPage] = useState(1);
    const [rowsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);


    const fetchelgibilty = () => {
        setLoading(true);

        API.post("list_checkeligibilityform/condition", {
            language_id: languageId,
            name: "",
            email: "",
            search: search,
            rowsPerPage,
            pageNumber,
        })
            .then((response) => {
                const allData = response.data?.data || [];
                const totalRecords = response.data?.totalRecords || 0;
                const pages = Math.ceil(totalRecords / rowsPerPage);
                setTotalPages(pages);

                const formattedData = allData.map((item) => {
                    const highestEduObj = item.points_list.find(p => p.heading === "Highest Education");
                    const experienceObj = item.points_list.find(p => p.heading === "Job Experience");
                    const serviceObj = item.points_list.find(p => p.heading === "Service Type");

                    return {
                        id: item.checkeligibilityform_id,
                        name: item.name,
                        email: item.email,
                        phone_number: item.phone_number,
                        totalPoints: item.totalPoints,
                        highestEducation: highestEduObj?.name || "--",
                        jobExperience: experienceObj?.name || "--",
                    };
                });


                setCandidate(formattedData);
            })

            .catch((err) => {
                console.error("Error fetching eligibility list:", err);
            })
            .finally(() => setLoading(false));
    };
    useEffect(() => {
        fetchelgibilty();
    }, [pageNumber, languageId]);



    const handleNext = () => {
        if (pageNumber < totalPages) setPage(pageNumber + 1);
    };

    const handlePrev = () => {
        if (pageNumber > 1) setPage(pageNumber - 1);
    };
    const handleSearch = () => {
        localStorage.removeItem("candidatePage");
        setPage(1);
        fetchelgibilty();
    };

    useEffect(() => {
        if (location.state?.pageNumber) {
            setPage(location.state.pageNumber);

            // clear state AFTER restoring
            navigate(location.pathname, { replace: true });
        }
    }, [location.state]);



    return (
        <div className="admin-container">

            <div className="news-header">
                <h2 className="news-title">Candidate List</h2>
            </div>

            <div className="category-filter-row1">
                <div className="category-filter-block1">
                    <label>Search</label>
                    <div className="category-input-container1">
                        <input
                            placeholder="Search candidates..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="category-input-field1"
                        />
                    </div>
                </div>

                <div className="filter-block">
                    <label>Language</label>
                    <div className="input-container">
                        <select
                            value={languageId}
                            onChange={(e) => {
                                setLanguageId(Number(e.target.value));
                                setPage(1);
                            }}

                            className="input-field"
                        >

                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>
                </div>

                <div className="filter-btn-wrapper" onClick={handleSearch}>
                    <img src={Search} alt="Filter" className="icon-btnf" />
                </div>
            </div>

            <div className="admin-table-wrapper">
                {loading ? (
                    <Loading />
                ) : (
                    <>
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Highest Education</th>
                                    <th>Experience</th>
                                    <th>Total Points</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            {candidate.length > 0 ? (
                                <tbody>
                                    {candidate.map((admin) => (

                                        <tr key={admin.id}>
                                            <td>{candidate.indexOf(admin) + 1}</td>
                                            <td>{admin.name}</td>
                                            <td>{admin.email}</td>
                                            <td>{admin.phone_number}</td>
                                            <td>{admin.highestEducation}</td>
                                            <td>{admin.jobExperience}</td>
                                            <td>{admin.totalPoints}</td>
                                            <td>
                                                <img
                                                    src={AdminView}
                                                    alt="View"
                                                    className="admin-icon-btn"
                                                    onClick={() =>
                                                        navigate(`/eligibilitycandidateview/${admin.id}`, {
                                                            state: { pageNumber }
                                                        })
                                                    }

                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>

                            ) : (
                                <tbody>
                                    <tr>
                                        <td colSpan="8" style={{ textAlign: "center" }}>
                                            No candidate found.
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                        {/* Pagination */}
                        {totalPages > 1 && (
                            <div className="pagination-container">
                                <button
                                    className="pagination-btn"
                                    onClick={handlePrev}
                                    disabled={pageNumber === 1}
                                >
                                    Prev
                                </button>

                                {/* Page Numbers */}
                                {(() => {
                                    const pageNumbers = [];
                                    const maxVisible = 5;

                                    if (totalPages <= maxVisible) {
                                        for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);

                                    } else {
                                        if (pageNumber <= 3) {
                                            pageNumbers.push(1, 2, 3, 4, "...", totalPages);

                                        } else if (pageNumber >= totalPages - 2) {
                                            pageNumbers.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);

                                        } else {
                                            pageNumbers.push(
                                                1,
                                                "...",
                                              
                                                pageNumber - 1,
                                                pageNumber,
                                                pageNumber + 1,
                                               
                                                "...",
                                                totalPages
                                            );
                                        }
                                    }

                                    return pageNumbers.map((num, index) =>
                                        num === "..." ? (
                                            <span key={`ellipsis-${index}`} className="pagination-ellipsis">
                                                ...
                                            </span>
                                        ) : (
                                            <button
                                                key={num}
                                                className={`pagination-btn ${pageNumber === num ? "active" : ""}`}
                                                onClick={() => setPage(num)}
                                            >
                                                {num}
                                            </button>
                                        )
                                    );
                                })()}
                                <button
                                    className="pagination-btn"
                                    onClick={handleNext}
                                    disabled={pageNumber === totalPages}
                                >
                                    Next
                                </button>
                            </div>
                        )}
                    </>

                )}


            </div>

        </div >
    );
};

export default EligibilityCandidate;

